import React from "react";
import PropTypes from "prop-types";
import NeoButton from "../../../../../components/Common/NeoButton";
import NeoFinancialTable from "../../../../../components/Common/NeoFinancialTable";

const DetailBilling = ({ tenant, faturas, setFaturas, handleLogAction, tenantSummaryData, onRegisterPayment }) => {
    // Colunas da NeoFinancialTable para Faturas (compactadas para evitar estouro lateral)
    const faturasColumns = [
        {
            key: "id",
            label: "Código / Status",
            width: "20%",
            render: (row) => (
                <div>
                    <span className="font-monospace fw-bold d-block">{row.id}</span>
                    <span className={
                        row.status === "pago"
                            ? "badge bg-success-subtle text-success px-2 py-1 font-size-11 mt-0.5"
                            : "badge bg-warning-subtle text-warning px-2 py-1 font-size-11 mt-0.5"
                    }>
                        {row.status === "pago" ? "Paga" : "Pendente"}
                    </span>
                </div>
            )
        },
        {
            key: "amount",
            label: "Valor / Vencimento",
            width: "25%",
            render: (row) => (
                <div>
                    <div className="fw-semibold">R$ {row.amount.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}</div>
                    <span className="text-xs text-muted d-block">{new Date(row.dueDate).toLocaleDateString("pt-BR")}</span>
                </div>
            )
        },
        {
            key: "paidAt",
            label: "Pagamento / Método",
            width: "30%",
            render: (row) => (
                <div>
                    {row.paidAt ? (
                        <>
                            <div className="fw-semibold text-success">{new Date(row.paidAt).toLocaleDateString("pt-BR")}</div>
                            <span className="text-xs text-muted d-block">{row.method} ({row.gateway === "manual" ? "Manual" : "Gateway"})</span>
                        </>
                    ) : (
                        <span className="text-muted">—</span>
                    )}
                </div>
            )
        },
        {
            key: "actions",
            label: "Ações",
            width: "25%",
            align: "center",
            render: (row) => (
                <div className="d-flex justify-content-center gap-1">
                    {row.status === "pending" ? (
                        <NeoButton
                            variant="success"
                            size="sm"
                            square
                            onClick={() => onRegisterPayment(row)}
                            title="Dar Baixa"
                            icon="mdi-check"
                        />
                    ) : (
                        <div style={{ width: "30px" }} />
                    )}
                    <NeoButton
                        variant="soft-secondary"
                        size="sm"
                        square
                        onClick={() => alert("Recibo simulado gerado e enviado para o WhatsApp do cliente!")}
                        title="Recibo"
                        icon="mdi-receipt"
                    />
                </div>
            )
        }
    ];

    return (
        <div>
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h6 className="fw-bold text-dark m-0">Histórico de Faturamento e Pagamentos</h6>
                <NeoButton variant="primary" size="sm" onClick={() => {
                    const newFatura = {
                        id: `pay_${Date.now().toString().substring(10)}`,
                        amount: tenant.amount,
                        dueDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString().split("T")[0],
                        paidAt: null,
                        status: "pending",
                        method: "Pix",
                        gateway: "manual"
                    };
                    setFaturas([newFatura, ...faturas]);
                    handleLogAction("invoice_created_manual", "Gerou fatura de cobrança extra manualmente");
                }}>
                    <i className="ph-light ph-plus me-1" /> Emitir Nova Fatura
                </NeoButton>
            </div>
            <div className="w-100">
                <NeoFinancialTable
                    columns={faturasColumns}
                    data={faturas}
                    summaryData={tenantSummaryData}
                    searchPlaceholder="Buscar faturas..."
                />
            </div>
        </div>
    );
};

DetailBilling.propTypes = {
    tenant: PropTypes.object.isRequired,
    faturas: PropTypes.array.isRequired,
    setFaturas: PropTypes.func.isRequired,
    handleLogAction: PropTypes.func.isRequired,
    tenantSummaryData: PropTypes.array.isRequired,
    onRegisterPayment: PropTypes.func.isRequired
};

export default DetailBilling;
